import { useState } from "react";
import { ArrowsClockwise, X } from "@phosphor-icons/react";
import { useVersionCheck } from "@/hooks/useVersionCheck";

export default function UpdateBanner() {
  const updateAvailable = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);
  if (!updateAvailable || dismissed) return null;
  return (
    <div
      data-testid="update-banner"
      role="status"
      className="fixed inset-x-0 top-0 z-[80] flex items-center justify-center gap-3 bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-lg"
    >
      <ArrowsClockwise size={18} weight="bold" className="shrink-0" />
      <span>A new version of the app is available.</span>
      <button
        data-testid="update-banner-refresh-btn"
        onClick={() => window.location.reload()}
        className="rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-green-700 transition-colors hover:bg-green-50"
      >
        Refresh now
      </button>
      <button
        data-testid="update-banner-dismiss-btn"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="ml-1 rounded p-1 text-green-100 transition-colors hover:bg-green-700 hover:text-white"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
}
